import io from 'socket.io-client'

export const socket = io.connect('https://api.mypoet360.com');